import React from "react";
import { motion } from "framer-motion";
import PeopleIcon from "@mui/icons-material/People";
import { PeopleIconWrapper } from "./styles";

export interface KLPeopleIconProps {
  /**
   * Size of the icon
   */
  size?: "small" | "medium" | "large";
  /**
   * Enable tap feedback animation (mobile-first)
   */
  animated?: boolean;
  /**
   * Add circular background
   */
  withBackground?: boolean;
  /**
   * Use custom gradient styling
   */
  customStyle?: boolean;
}

const KLPeopleIcon: React.FC<KLPeopleIconProps> = ({
  size = "medium",
  animated = false,
  withBackground = true,
  customStyle = true,
}) => {
  const Component = animated ? motion.div : "div";

  return (
    <PeopleIconWrapper
      as={Component}
      $size={size}
      $withBackground={withBackground && customStyle}
      $customStyle={customStyle}
      {...(animated
        ? {
            whileTap: { scale: 0.95 },
            transition: { type: "spring", stiffness: 300, damping: 20 },
          }
        : {})}
    >
      <PeopleIcon />
    </PeopleIconWrapper>
  );
};

export default KLPeopleIcon;
